import React from "react";
import LayoutShell from "../components/LayoutShell";
import Card from "../components/Card";
import Button from "../components/Button";
import "./DashboardPage.css";

export default function DashboardPage() {
  return (
    <LayoutShell active="dashboard">
      <section className="dashboard-hero">
        <div className="hero-title">Good morning, Resident</div>
        <div className="hero-subtitle">
          Here’s a quick overview of your Crown Residences activity.
        </div>
      </section>

      <section className="dashboard-grid">
        <Card title="Announcements">
          <ul className="list">
            <li>Water shutdown • Tower B • 6–8 PM</li>
            <li>Lift maintenance • Tower A • Tomorrow</li>
          </ul>
        </Card>

        <Card title="Upcoming booking">
          <div className="card-value">Gym • Today 7:00 PM</div>
          <div className="card-sub">Tower A • Level 3</div>
        </Card>

        <Card title="Outstanding balance">
          <div className="card-value">€ 0.00</div>
          <div className="card-sub">You’re all settled for this month.</div>
        </Card>

        <Card
          title="Quick actions"
          action={<Button variant="primary">Book amenity</Button>}
        >
          <div className="card-sub">
            Reserve gym, pool, lounge, or guest suite in a few taps.
          </div>
        </Card>
      </section>
    </LayoutShell>
  );
}